/** Mirrors invoicing-frontend shared/web-component/events.ts wire values. */
export const CUSTOMER_CREDIT_ACCOUNT_PAY_BALANCE_MOUNT_READY_EVENT =
  'invoicing:customer-credit-account-pay-balance-mount-ready' as const;

export const CUSTOMER_CREDIT_ACCOUNT_PAY_BALANCE_MOUNT_REMOVED_EVENT =
  'invoicing:customer-credit-account-pay-balance-mount-removed' as const;

export interface CustomerCreditAccountPayBalanceMountLifecycleDetail {
  mountPoint: HTMLElement;
}

export interface PayBalanceMountHandlers {
  mountPayBalance: (mountPoint: HTMLElement) => void;
  unmountPayBalance: (mountPoint: HTMLElement) => void;
}
